module.exports = __webpack_public_path__ + "media/users/images/federated-sign-in-icon-c781f2abebf8c1f3fd06c2a97379ad73.svg";